import React, { useState } from 'react'
import {
  Box,
  Button,
  ButtonGroup,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText
} from '@mui/material'
import Download from '@mui/icons-material/Download'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import {
  DOWNLOAD_ACTION_TEXT_SX,
  getDownloadActionContentSx,
  getDownloadActionIconSize,
  getDownloadActionIconSlotSx,
  getDownloadSplitArrowSx,
  getDownloadSplitGroupSx,
  getDownloadSplitPrimarySx
} from './styles/downloadActionSx'

export default function DownloadSplitActionButton({
  text,
  label,
  onPrimaryClick,
  menuItems,
  density = 'toolbar',
  fullWidth,
  disabled = false,
  sx: sxProp,
  startIcon
}) {
  const displayText = text ?? label ?? 'Descargar'
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const resolvedFullWidth = fullWidth !== undefined ? fullWidth : density === 'card'
  const iconSize = getDownloadActionIconSize(density)
  const resolvedStartIcon =
    startIcon !== undefined ? startIcon : <Download sx={{ fontSize: iconSize }} />

  const groupSx = [
    getDownloadSplitGroupSx({ density, fullWidth: resolvedFullWidth }),
    ...(sxProp ? [sxProp] : [])
  ]

  const handleClose = () => setAnchorEl(null)

  return (
    <>
      <ButtonGroup variant="contained" disableElevation={false} sx={groupSx}>
        <Button
          disabled={disabled}
          fullWidth={false}
          onClick={onPrimaryClick}
          sx={getDownloadSplitPrimarySx({ density })}
        >
          <Box
            component="span"
            sx={getDownloadActionContentSx()}
          >
            <Box component="span" sx={getDownloadActionIconSlotSx({ density })}>
              {resolvedStartIcon}
            </Box>
            <Box component="span" sx={DOWNLOAD_ACTION_TEXT_SX}>
              {displayText}
            </Box>
            <Box component="span" sx={getDownloadActionIconSlotSx({ density, hidden: true })} />
          </Box>
        </Button>
        <Button
          disabled={disabled}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          aria-label="Más opciones de descarga"
          onClick={(e) => setAnchorEl(e.currentTarget)}
          sx={getDownloadSplitArrowSx({ density })}
        >
          <KeyboardArrowDown sx={{ fontSize: '1.125rem' }} />
        </Button>
      </ButtonGroup>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        MenuListProps={{ dense: true }}
      >
        {menuItems.map((item, i) => (
          <MenuItem
            key={item.key ?? i}
            onClick={async () => {
              try {
                await item.onClick()
              } finally {
                handleClose()
              }
            }}
          >
            {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
            <ListItemText primary={item.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
